import { captureError } from "@/lib/errors/capture-error";
import { resetPassword } from "@/lib/supabase";
import { Button, Form, FormField, FormItem, FormLabel, Input, Typography, useConfirm } from "@backpac/monica";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

export function RequestResetPasswordPage() {
  const { confirm } = useConfirm();
  const form = useForm<{ email: string }>({
    defaultValues: {
      email: "",
    },
    resolver: zodResolver(z.object({ email: z.string().email() })),
  });

  return (
    <div className="flex flex-col gap-6">
      <Typography asChild size="xl" font="unbounded">
        <h1>Forgot your password?</h1>
      </Typography>
      <Typography size="sm" weight={350}>
        Please enter your email, and we'll send you a link to reset your password
      </Typography>

      <Form {...form}>
        <form
          className="flex flex-col"
          id="email-verify"
          onSubmit={form.handleSubmit(async (data) => {
            try {
              await resetPassword(data.email);
              confirm({
                className: "max-w-[432px]",
                title: "Check your inbox",
                description:
                  "If the email is linked to an account, you'll get instructions to reset your password. Check your spam folder if it doesn't arrive, and confirm the correct email was entered.",
                confirmText: "Okay",
                cancelText: "Close",
              });
            } catch (error: unknown) {
              captureError(error);
            }
          })}
        >
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Email</FormLabel>
                <Input type="text" placeholder="Your email address" {...field} />
              </FormItem>
            )}
          />
        </form>
        <Button
          form="email-verify"
          disabled={form.formState.isSubmitting || !form.formState.isValid}
          type="submit"
          className="w-full"
          size="lg"
        >
          Send
        </Button>
      </Form>
    </div>
  );
}
